module.exports = __webpack_public_path__ + "app/registrations-request/registration-request-detail-1lARZBkw.html";